// SEO service landing pages content (DE + EN). Each service has its own
// indexable URL, unique title/description/H1/H2, FAQ, structured data and
// internal links. Copy is conversion-oriented and written naturally around
// real commercial search intents — no keyword stuffing.

const B = "https://static.prod-images.emergentagent.com/jobs/a0cffeb8-45aa-428a-a51d-c00d17ce097e/images/";
const IMG = {
  website: B + "45a0b2a09c129b4dadecccc3e784baf3e1b0110d1da9be2b60c9ec5fb6a35a6f.jpeg",
  app: B + "566d027d1a4ead2bb0ef3edbd5b1ae830197ffd9adfba0c66cd6d95cc96ae1a2.jpeg",
  aiagent: B + "d29466aca4b14ccf8cee84c66a386952363771778d7cb4294931a0e9d72866e9.jpeg",
  digital: B + "0111d31a65007fa78ed57fa68819396beecf969f7f8b43053add067d266fec46.jpeg",
  books: B + "a38ad4d465e8a84b9726a744f6fc9d98d277a3d6c7cf3635ba6ca2e3331f66cb.jpeg",
};

export const SERVICE_LANDINGS = [
  // ── 1. WEBSITE ───────────────────────────────────────────────────────────
  {
    key: "website",
    image: IMG.website,
    related: { projects: ["andrea-aesthetic-heilpraktik", "minijob-ai"], services: ["app", "ai-agent"] },
    de: {
      slug: "website-erstellen-lassen",
      path: "/de/website-erstellen-lassen",
      title: "Website erstellen lassen — professionell & launch-fertig | WERKVERDUNG",
      description:
        "Professionelle Website erstellen lassen: Design, Entwicklung und SEO-Grundlage für Unternehmen und Selbstständige — von der Idee bis zum Launch. Jetzt Projekt starten.",
      eyebrow: "Leistung — Websites",
      h1: "Website erstellen lassen",
      intro:
        "Sie wollen eine professionelle Website erstellen lassen, die wirkt wie ein Studio-Auftritt und Kunden gewinnt? Ich baue Websites für Unternehmen, Selbstständige und Marken — von der Struktur über das Design bis zur fertigen, launch-bereiten Seite.",
      sections: [
        {
          h2: "Website für Unternehmen erstellen lassen",
          body:
            "Ihre Website ist der erste Eindruck. Ich entwickle eine klare, schnelle und überzeugende Präsenz mit durchdachter Informationsarchitektur — damit Besucher sofort verstehen, was Sie anbieten, und zu Kunden werden.",
        },
        {
          h2: "Design & Entwicklung aus einer Hand",
          body:
            "Von responsivem Design über sauberen Build bis zur technischen SEO-Grundlage: Sie bekommen alles aus einer Hand, ohne Agentur-Overhead. Jede Seite wird für Geschwindigkeit, Mobilgeräte und Auffindbarkeit gebaut.",
        },
        {
          h2: "Bis zum Launch begleitet",
          body:
            "Ich liefere nicht nur ein Design — ich bringe Ihre Website bis zum Launch. Domain, Performance, Meta-Daten und Übergabe inklusive, damit Sie sofort online gehen können.",
        },
      ],
      deliver: ["Responsive Design & Build", "Klare Informationsarchitektur", "Technische SEO-Grundlage", "Launch-Vorbereitung & Übergabe"],
      faq: [
        { q: "Was kostet es, eine Website erstellen zu lassen?", a: "Der Preis richtet sich nach Umfang und Funktionen. Nach einem kurzen Gespräch erhalten Sie ein klares, festes Angebot ohne versteckte Kosten." },
        { q: "Wie lange dauert die Erstellung einer Website?", a: "Eine fokussierte Unternehmens-Website ist typischerweise in wenigen Wochen launch-fertig — abhängig von Inhalten und Funktionsumfang." },
        { q: "Ist SEO enthalten?", a: "Ja. Jede Website erhält eine solide technische SEO-Grundlage: saubere Struktur, Meta-Daten, schnelle Ladezeiten und indexierbare Seiten." },
      ],
      serviceName: "Website Erstellung",
      serviceType: "Webdesign & Webentwicklung",
      ctaTitle: "Bereit für Ihre neue Website?",
      ctaText: "Erzählen Sie mir von Ihrem Projekt — ich melde mich mit den nächsten Schritten.",
    },
    en: {
      slug: "website-development",
      path: "/en/website-development",
      title: "Professional Website Development Service — Built to Launch | WERKVERDUNG",
      description:
        "Professional website development for businesses and professionals: design, build and an SEO foundation — from idea to launch. Build a website for your business today.",
      eyebrow: "Service — Websites",
      h1: "Professional Website Development",
      intro:
        "Need a professional website development service that looks like a studio build and turns visitors into clients? I build websites for businesses, professionals and brands — from structure and design to a finished, launch-ready site.",
      sections: [
        {
          h2: "Build a website for your business",
          body:
            "Your website is the first impression. I create a clear, fast and convincing presence with thoughtful information architecture — so visitors instantly understand what you offer and become customers.",
        },
        {
          h2: "Design & development in one place",
          body:
            "From responsive design to a clean build and a technical SEO foundation — you get everything from one person, without agency overhead. Every page is built for speed, mobile and discoverability.",
        },
        {
          h2: "Delivered all the way to launch",
          body:
            "I don't just hand over a design — I take your website to launch. Domain, performance, meta data and handover included, so you can go live right away.",
        },
      ],
      deliver: ["Responsive design & build", "Clear information architecture", "Technical SEO foundation", "Launch preparation & handover"],
      faq: [
        { q: "How much does professional website development cost?", a: "Pricing depends on scope and features. After a short call you get a clear, fixed quote with no hidden costs." },
        { q: "How long does it take to build a website?", a: "A focused business website is typically launch-ready in a few weeks, depending on content and functionality." },
        { q: "Is SEO included?", a: "Yes. Every website gets a solid technical SEO foundation: clean structure, meta data, fast load times and indexable pages." },
      ],
      serviceName: "Website Development",
      serviceType: "Web Design & Development",
      ctaTitle: "Ready for your new website?",
      ctaText: "Tell me about your project — I'll get back to you with the next steps.",
    },
  },

  // ── 2. APP ─────────────────────────────────────────────────────────────────
  {
    key: "app",
    image: IMG.app,
    related: { projects: ["minijob-ai"], services: ["website", "ai-agent"] },
    de: {
      slug: "app-entwickeln-lassen",
      path: "/de/app-entwickeln-lassen",
      title: "App entwickeln lassen — Web & Mobile App vom Konzept zum Launch | WERKVERDUNG",
      description:
        "Mobile App oder Web-App entwickeln lassen: vom Konzept über UI/UX bis zum nutzbaren Produkt. KI-gestützt, schnell und launch-fertig. Jetzt App-Projekt starten.",
      eyebrow: "Leistung — Apps",
      h1: "App entwickeln lassen",
      intro:
        "Sie haben eine Produktidee und wollen eine App entwickeln lassen, die Menschen wirklich nutzen? Ich baue Web- und Mobile-Apps — vom Konzept über das Interface bis zum funktionierenden, launch-fertigen Produkt.",
      sections: [
        {
          h2: "Mobile App entwickeln lassen",
          body:
            "Von der ersten Skizze bis zum nutzbaren Build: Ich verwandle Ihre Idee in ein durchdachtes, benutzerfreundliches Produkt — mit klarem Fokus auf das, was Nutzer wirklich brauchen.",
        },
        {
          h2: "Konzept, UI/UX und Build",
          body:
            "Produktkonzept, Interface-Design und Entwicklung greifen ineinander. So entsteht keine Sammlung von Features, sondern ein stimmiges Produkt, das sich gut anfühlt und einfach funktioniert.",
        },
        {
          h2: "KI-gestützt und effizient",
          body:
            "Mit KI-gestützten Workflows baue ich schneller und schlanker — ohne Kompromisse bei Qualität. Ideal für Gründer und Unternehmen, die ihr MVP zügig in die Realität bringen wollen.",
        },
      ],
      deliver: ["Produktkonzept", "UI/UX-Design", "Funktionsfähiger Build", "KI-gestützte Effizienz"],
      faq: [
        { q: "Entwickeln Sie sowohl Web- als auch Mobile-Apps?", a: "Ja. Ich baue Web-Apps und mobile Anwendungen — je nachdem, was für Ihr Produkt und Ihre Zielgruppe am meisten Sinn ergibt." },
        { q: "Kann ich mit einem MVP starten?", a: "Absolut. Oft ist der beste Weg ein fokussiertes MVP, das die Kernidee beweist und dann Schritt für Schritt wächst." },
        { q: "Wie läuft ein App-Projekt ab?", a: "Idee, Strategie, Build, Refine und Launch — ein klarer Prozess, bei dem Sie in jeder Phase wissen, was passiert." },
      ],
      serviceName: "App-Entwicklung",
      serviceType: "Web- & Mobile-App-Entwicklung",
      ctaTitle: "Lassen Sie uns Ihre App bauen",
      ctaText: "Beschreiben Sie Ihre Idee — ich zeige Ihnen den schnellsten Weg zum nutzbaren Produkt.",
    },
    en: {
      slug: "app-development",
      path: "/en/app-development",
      title: "App Development Service — Web & Mobile Apps to Launch | WERKVERDUNG",
      description:
        "Mobile app or web app development service: from concept and UI/UX to a usable product. AI-assisted, fast and launch-ready. Start your app project today.",
      eyebrow: "Service — Apps",
      h1: "App Development Service",
      intro:
        "Got a product idea and need an app development service that ships something people actually use? I build web and mobile apps — from concept and interface to a working, launch-ready product.",
      sections: [
        {
          h2: "Mobile app development",
          body:
            "From first sketch to usable build: I turn your idea into a thoughtful, user-friendly product with a clear focus on what users really need.",
        },
        {
          h2: "Concept, UI/UX and build",
          body:
            "Product concept, interface design and development work together. The result isn't a pile of features — it's a coherent product that feels good and simply works.",
        },
        {
          h2: "AI-assisted and efficient",
          body:
            "With AI-assisted workflows I build faster and leaner without compromising quality. Ideal for founders and businesses who want to get their MVP into reality quickly.",
        },
      ],
      deliver: ["Product concept", "UI/UX design", "Working build", "AI-assisted efficiency"],
      faq: [
        { q: "Do you build both web and mobile apps?", a: "Yes. I build web apps and mobile applications, depending on what makes the most sense for your product and audience." },
        { q: "Can I start with an MVP?", a: "Absolutely. Often the best path is a focused MVP that proves the core idea and then grows step by step." },
        { q: "How does an app project work?", a: "Idea, strategy, build, refine and launch — a clear process where you know what's happening at every stage." },
      ],
      serviceName: "App Development",
      serviceType: "Web & Mobile App Development",
      ctaTitle: "Let's build your app",
      ctaText: "Describe your idea — I'll show you the fastest path to a usable product.",
    },
  },

  // ── 3. AI AGENT ─────────────────────────────────────────────────────────────
  {
    key: "ai-agent",
    image: IMG.aiagent,
    related: { projects: ["minijob-ai", "ai-from-zero-to-pro"], services: ["app", "digital-product"] },
    de: {
      slug: "ki-agent-erstellen-lassen",
      path: "/de/ki-agent-erstellen-lassen",
      title: "KI Agent erstellen lassen — KI-Automatisierung für Ihr Business | WERKVERDUNG",
      description:
        "KI Agent erstellen lassen und Prozesse automatisieren: individuelle KI-Assistenten und KI-Automatisierung, die echte Aufgaben übernehmen. Jetzt Automatisierungs-Projekt starten.",
      eyebrow: "Leistung — KI & Automatisierung",
      h1: "KI Agent erstellen lassen",
      intro:
        "Sie wollen einen KI Agent erstellen lassen, der wiederkehrende Aufgaben übernimmt und Ihr Team entlastet? Ich baue individuelle KI-Assistenten und KI-Automatisierungen, die sich in Ihre bestehenden Abläufe einfügen — praktisch, nicht nur ein Chatbot.",
      sections: [
        {
          h2: "KI Automatisierung erstellen lassen",
          body:
            "Von der Lead-Bearbeitung über Kundenservice bis zur Datenaufbereitung: Ich automatisiere die Aufgaben, die Zeit kosten — mit KI-Agenten, die zuverlässig arbeiten und messbar entlasten.",
        },
        {
          h2: "Individuell auf Ihr Business zugeschnitten",
          body:
            "Kein Baukasten von der Stange. Ihr KI-Agent wird auf Ihre Prozesse, Ihre Sprache und Ihre Tools abgestimmt — damit er echte Ergebnisse liefert statt generischer Antworten.",
        },
        {
          h2: "Von der Idee zur Integration",
          body:
            "Ich begleite den ganzen Weg: Anwendungsfall definieren, Agent bauen, testen und in Ihre bestehenden Systeme integrieren — bis er im Alltag zuverlässig läuft.",
        },
      ],
      deliver: ["Anwendungsfall & Konzept", "Individueller KI-Agent", "Automatisierte Workflows", "Integration & Test"],
      faq: [
        { q: "Was kann ein KI-Agent für mein Unternehmen tun?", a: "Er übernimmt wiederkehrende Aufgaben wie Anfragen beantworten, Daten sortieren oder Prozesse anstoßen — rund um die Uhr und ohne manuellen Aufwand." },
        { q: "Lässt sich der KI-Agent in meine Tools integrieren?", a: "Ja. Der Agent wird so gebaut, dass er mit Ihren bestehenden Tools und Systemen zusammenarbeitet." },
        { q: "Brauche ich technisches Vorwissen?", a: "Nein. Sie beschreiben das Problem — ich kümmere mich um die technische Umsetzung und die Übergabe." },
      ],
      serviceName: "KI-Agent & Automatisierung",
      serviceType: "KI-Automatisierung & KI-Agent-Entwicklung",
      ctaTitle: "Prozesse mit KI automatisieren",
      ctaText: "Sagen Sie mir, welche Aufgabe Zeit frisst — ich zeige Ihnen, wie ein KI-Agent sie übernimmt.",
    },
    en: {
      slug: "ai-agent-development",
      path: "/en/ai-agent-development",
      title: "AI Agent Development — Custom AI Automation for Your Business | WERKVERDUNG",
      description:
        "AI agent development and AI automation: custom AI assistants that handle real tasks and free up your team. Start your AI automation project today.",
      eyebrow: "Service — AI & Automation",
      h1: "AI Agent Development",
      intro:
        "Want AI agent development that takes over repetitive work and frees up your team? I build custom AI assistants and AI automation that fit into your existing workflows — practical, not just another chatbot.",
      sections: [
        {
          h2: "AI automation development",
          body:
            "From lead handling to customer service and data prep: I automate the tasks that eat time — with AI agents that work reliably and reduce workload measurably.",
        },
        {
          h2: "Tailored to your business",
          body:
            "No off-the-shelf template. Your AI agent is tuned to your processes, your language and your tools — so it delivers real results instead of generic answers.",
        },
        {
          h2: "From idea to integration",
          body:
            "I guide the whole way: define the use case, build the agent, test it and integrate it into your existing systems — until it runs reliably day to day.",
        },
      ],
      deliver: ["Use case & concept", "Custom AI agent", "Automated workflows", "Integration & testing"],
      faq: [
        { q: "What can an AI agent do for my business?", a: "It handles repetitive tasks like answering enquiries, sorting data or triggering processes — around the clock and without manual effort." },
        { q: "Can the AI agent integrate with my tools?", a: "Yes. The agent is built to work with your existing tools and systems." },
        { q: "Do I need technical knowledge?", a: "No. You describe the problem — I handle the technical implementation and handover." },
      ],
      serviceName: "AI Agent & Automation",
      serviceType: "AI Automation & AI Agent Development",
      ctaTitle: "Automate your processes with AI",
      ctaText: "Tell me which task eats your time — I'll show you how an AI agent can take it over.",
    },
  },

  // ── 4. DIGITAL PRODUCT ──────────────────────────────────────────────────────
  {
    key: "digital-product",
    image: IMG.digital,
    related: { projects: ["ai-from-zero-to-pro"], services: ["ai-agent", "kdp"] },
    de: {
      slug: "digitale-produkte-erstellen-lassen",
      path: "/de/digitale-produkte-erstellen-lassen",
      title: "Digitale Produkte erstellen lassen — Kurse, Tools & Downloads | WERKVERDUNG",
      description:
        "Digitale Produkte erstellen lassen: Online-Kurse, KI-Tools und downloadbare Produkte — konzipiert, gebaut und verkaufsfertig. Jetzt Ihr digitales Produkt starten.",
      eyebrow: "Leistung — Digitale Produkte",
      h1: "Digitale Produkte erstellen lassen",
      intro:
        "Sie wollen Ihr Wissen als Produkt verkaufen und digitale Produkte erstellen lassen? Ich konzipiere und baue Kurse, KI-Tools und downloadbare Produkte — von der Struktur über das Interface bis zur verkaufsfertigen Seite.",
      sections: [
        {
          h2: "Vom Wissen zum verkaufbaren Produkt",
          body:
            "Ein gutes digitales Produkt braucht Struktur, klares Design und einen überzeugenden Verkaufsweg. Ich verwandle Ihre Idee in ein Produkt, das Menschen kaufen und nutzen wollen.",
        },
        {
          h2: "Kurse, Tools und Downloads",
          body:
            "Ob Online-Kurs, KI-gestütztes Tool oder Download-Produkt: Ich baue die passende Grundlage — inklusive Interface, Verkaufsseite und launch-fähigen Assets.",
        },
        {
          h2: "Startklar bis zum Launch",
          body:
            "Sie bekommen kein halbes Produkt, sondern ein startklares Paket: gestaltet, gebaut und bereit, veröffentlicht und verkauft zu werden.",
        },
      ],
      deliver: ["Produktstruktur", "Interface & Design", "Verkaufsseite", "Launch-fähige Assets"],
      faq: [
        { q: "Welche digitalen Produkte kann ich erstellen lassen?", a: "Zum Beispiel Online-Kurse, KI-gestützte Tools, Templates und downloadbare Produkte — passend zu Ihrem Wissen und Ihrer Zielgruppe." },
        { q: "Kümmern Sie sich auch um die Verkaufsseite?", a: "Ja. Zum Produkt gehört eine überzeugende Verkaufsseite, die Interessenten zu Käufern macht." },
        { q: "Auf welchen Plattformen kann ich verkaufen?", a: "Etwa über Gumroad, den eigenen Shop oder andere Plattformen — je nachdem, was für Ihr Produkt am besten passt." },
      ],
      serviceName: "Digitale Produktentwicklung",
      serviceType: "Digitale Produktentwicklung",
      ctaTitle: "Ihr digitales Produkt wartet",
      ctaText: "Erzählen Sie mir, was Sie verkaufen wollen — ich baue das Produkt drumherum.",
    },
    en: {
      slug: "digital-product-development",
      path: "/en/digital-product-development",
      title: "Digital Product Development — Courses, Tools & Downloads | WERKVERDUNG",
      description:
        "Digital product development: online courses, AI tools and downloadable products — designed, built and ready to sell. Start your digital product today.",
      eyebrow: "Service — Digital Products",
      h1: "Digital Product Development",
      intro:
        "Want to sell your knowledge as a product with digital product development done for you? I design and build courses, AI tools and downloadable products — from structure and interface to a ready-to-sell page.",
      sections: [
        {
          h2: "From knowledge to a sellable product",
          body:
            "A good digital product needs structure, clear design and a convincing path to purchase. I turn your idea into a product people want to buy and use.",
        },
        {
          h2: "Courses, tools and downloads",
          body:
            "Whether an online course, an AI-powered tool or a download product: I build the right foundation — including interface, sales page and launch-ready assets.",
        },
        {
          h2: "Ready to ship at launch",
          body:
            "You don't get half a product — you get a ready-to-ship package: designed, built and ready to be published and sold.",
        },
      ],
      deliver: ["Product structure", "Interface & design", "Sales page", "Launch-ready assets"],
      faq: [
        { q: "What kinds of digital products can you build?", a: "For example online courses, AI-powered tools, templates and downloadable products — matched to your knowledge and audience." },
        { q: "Do you handle the sales page too?", a: "Yes. Every product includes a convincing sales page that turns interested visitors into buyers." },
        { q: "Which platforms can I sell on?", a: "Such as Gumroad, your own shop or other platforms, depending on what fits your product best." },
      ],
      serviceName: "Digital Product Development",
      serviceType: "Digital Product Development",
      ctaTitle: "Your digital product is waiting",
      ctaText: "Tell me what you want to sell — I'll build the product around it.",
    },
  },

  // ── 5. AMAZON KDP BOOK ──────────────────────────────────────────────────────
  {
    key: "kdp",
    image: IMG.books,
    related: { projects: ["willowbrook-series", "poetcore", "dark-cottagecore-series"], services: ["digital-product", "website"] },
    de: {
      slug: "amazon-kdp-buch-erstellen-lassen",
      path: "/de/amazon-kdp-buch-erstellen-lassen",
      title: "Amazon KDP Buch erstellen lassen — Cover, Layout & Veröffentlichung | WERKVERDUNG",
      description:
        "Amazon KDP Buch erstellen lassen: Cover-Design, Innenlayout und KDP-fertige Dateien für Ihre Veröffentlichung. Buch professionell auf Amazon KDP veröffentlichen. Jetzt starten.",
      eyebrow: "Leistung — Bücher & Publishing",
      h1: "Amazon KDP Buch erstellen lassen",
      intro:
        "Sie wollen Ihr Buch professionell veröffentlichen und ein Amazon KDP Buch erstellen lassen? Ich gestalte Cover, Innenlayout und KDP-fertige Dateien — vom Manuskript bis zur fertigen Veröffentlichung, auch für ganze Buchreihen.",
      sections: [
        {
          h2: "Buch veröffentlichen auf Amazon KDP",
          body:
            "Ein Buch auf Amazon KDP zu veröffentlichen ist mehr als eine Datei hochzuladen. Ich sorge für ein Cover, das verkauft, ein sauberes Innenlayout und Dateien, die den KDP-Anforderungen entsprechen.",
        },
        {
          h2: "Cover, Layout und KDP-fertige Dateien",
          body:
            "Von der Cover-Gestaltung über das typografische Innenlayout bis zu druck- und KDP-fertigen Dateien — Sie bekommen ein professionelles Paket, mit dem Ihr Buch überzeugt.",
        },
        {
          h2: "Auch für ganze Buchreihen",
          body:
            "Sie planen mehr als ein Buch? Ich entwickle ein Reihen-System mit konsistentem Look, das Ihre Bücher als Marke zusammenhält und die Veröffentlichung skalierbar macht.",
        },
      ],
      deliver: ["Cover-Design", "Innenlayout", "KDP-fertige Dateien", "Reihen-System"],
      faq: [
        { q: "Übernehmen Sie die komplette KDP-Veröffentlichung?", a: "Ich liefere alle KDP-fertigen Dateien und begleite Sie bis zur Veröffentlichung, damit Ihr Buch technisch einwandfrei online geht." },
        { q: "Gestalten Sie auch das Cover?", a: "Ja. Ein verkaufsstarkes Cover-Design gehört zum Kern der Leistung — für einzelne Bücher und ganze Reihen." },
        { q: "Können Sie eine ganze Buchreihe umsetzen?", a: "Ja. Ich entwickle ein konsistentes Reihen-System, damit alle Bände als zusammengehörige Marke wirken." },
      ],
      serviceName: "Amazon KDP Buchgestaltung",
      serviceType: "Buchgestaltung & Amazon KDP Publishing",
      ctaTitle: "Ihr Buch verdient eine professionelle Veröffentlichung",
      ctaText: "Erzählen Sie mir von Ihrem Buch — ich bringe es KDP-fertig zur Veröffentlichung.",
    },
    en: {
      slug: "amazon-kdp-book-publishing",
      path: "/en/amazon-kdp-book-publishing",
      title: "Amazon KDP Book Publishing — Cover, Layout & Publishing | WERKVERDUNG",
      description:
        "Amazon KDP book publishing: cover design, interior layout and KDP-ready files for your release. Create and publish a book on Amazon professionally. Start today.",
      eyebrow: "Service — Books & Publishing",
      h1: "Amazon KDP Book Publishing",
      intro:
        "Want to publish your book professionally with Amazon KDP book publishing done for you? I design covers, interior layouts and KDP-ready files — from manuscript to finished release, including full book series.",
      sections: [
        {
          h2: "Create and publish a book on Amazon",
          body:
            "Publishing a book on Amazon KDP is more than uploading a file. I make sure you have a cover that sells, a clean interior layout and files that meet KDP requirements.",
        },
        {
          h2: "Cover, layout and KDP-ready files",
          body:
            "From cover design to typographic interior layout and print- and KDP-ready files — you get a professional package that makes your book stand out.",
        },
        {
          h2: "Built for full book series too",
          body:
            "Planning more than one book? I develop a series system with a consistent look that ties your books together as a brand and keeps publishing scalable.",
        },
      ],
      deliver: ["Cover design", "Interior layout", "KDP-ready files", "Series system"],
      faq: [
        { q: "Do you handle the full KDP publishing process?", a: "I deliver all KDP-ready files and guide you to publication so your book goes live technically flawless." },
        { q: "Do you design the cover as well?", a: "Yes. A high-converting cover design is at the core of the service — for single books and full series." },
        { q: "Can you produce a whole book series?", a: "Yes. I develop a consistent series system so all volumes read as one cohesive brand." },
      ],
      serviceName: "Amazon KDP Book Design",
      serviceType: "Book Design & Amazon KDP Publishing",
      ctaTitle: "Your book deserves a professional release",
      ctaText: "Tell me about your book — I'll get it KDP-ready and published.",
    },
  },
];

export const getLanding = (key) => SERVICE_LANDINGS.find((s) => s.key === key);
